import React from "react";
import { TopToolbar, EditButton, ListButton } from "react-admin";
import { Record } from "react-admin";

interface ViewProps {
  basePath?: string;
  data?: Record & { editable?: boolean };
  showEditButton?: boolean;
}

export const ViewActions = ({
  basePath,
  data,
  showEditButton = data?.editable,
  ...rest
}: ViewProps) => {
  return (
    <TopToolbar>
      {showEditButton && <EditButton basePath={basePath} record={data} />}
      <ListButton
        basePath={basePath}
        label="resources.common.labels.backToList"
      />
    </TopToolbar>
  );
};
